import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { FailureDescription } from "../../../model/form.model";
import { FailurePreviewDialogComponent } from "../failure-preview-dialog/failure-preview-dialog.component";
import { sortFailuresByCreatedOn } from "../../../../../utils/general.utils";

@Component({
  selector: 'failure-list-dialog',
  templateUrl: './failure-list-dialog.component.html',
  styleUrls: ['./failure-list-dialog.component.scss']
})
export class FailureListDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<FailureListDialogComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: FailureDescription[],
  ) {
    this.data = sortFailuresByCreatedOn(this.data, 'desc');
  }

  previewFailure(index: number) {
    const data = this.data[index];
    this.dialog.open(FailurePreviewDialogComponent, { data })
  }
}
